import { render } from "./DebugComponent.vue?vue&type=template&id=1602dd7f&scoped=true"
import script from "./DebugComponent.vue?vue&type=script&lang=ts"
export * from "./DebugComponent.vue?vue&type=script&lang=ts"

import "./DebugComponent.vue?vue&type=style&index=0&id=1602dd7f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1602dd7f"

export default script